var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseApiServiceFactory from '../base/BaseApiServiceFactory';
import GraphQlService from './GraphQlService';
var BaseGraphQlApiServiceFactory = /** @class */ (function (_super) {
    __extends(BaseGraphQlApiServiceFactory, _super);
    function BaseGraphQlApiServiceFactory(apiUrl, apiName) {
        var _this = _super.call(this, apiUrl) || this;
        _this.apiName = apiName;
        return _this;
    }
    BaseGraphQlApiServiceFactory.prototype.getGraphQlService = function (modelType, detailDescription, queryDescription, mutationKey) {
        if (!this.graphQlServices) {
            this.graphQlServices = new Map();
        }
        var cachedGraphQlService = this.graphQlServices.get(modelType);
        if (!cachedGraphQlService) {
            cachedGraphQlService = new GraphQlService(this.apiWrapper, this.apiName, detailDescription, queryDescription, mutationKey);
            this.graphQlServices.set(modelType, cachedGraphQlService);
        }
        return cachedGraphQlService;
    };
    BaseGraphQlApiServiceFactory.prototype.getExtendedGraphQlService = function (modelType, ExtendedGraphQlService) {
        if (!this.graphQlServices) {
            this.graphQlServices = new Map();
        }
        var cachedGraphQlService = this.graphQlServices.get(modelType);
        if (!cachedGraphQlService) {
            cachedGraphQlService = new ExtendedGraphQlService(this.apiWrapper, this.apiName);
            this.graphQlServices.set(modelType, cachedGraphQlService);
        }
        return cachedGraphQlService;
    };
    return BaseGraphQlApiServiceFactory;
}(BaseApiServiceFactory));
export default BaseGraphQlApiServiceFactory;
//# sourceMappingURL=BaseGraphQlApiServiceFactory.js.map